import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css'; // Core CSS
import 'lightgallery/css/lg-thumbnail.css'; // Thumbnail plugin
import 'lightgallery/css/lg-zoom.css';      // Zoom plugin
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import './gallery.scss';
import ResponsiveMasonry from "react-responsive-masonry";
import Masonry from "react-responsive-masonry";
import image1 from "../../assets/images/gallery/1.jpg"
import image2 from "../../assets/images/gallery/2.jpg"
import image3 from "../../assets/images/gallery/3.jpg"
import image4 from "../../assets/images/gallery/4.jpg"
import image5 from "../../assets/images/gallery/5.jpg"
import image6 from "../../assets/images/gallery/6.jpg"
import image7 from "../../assets/images/gallery/7.jpg"
import image8 from "../../assets/images/gallery/8.jpg"
import image9 from "../../assets/images/gallery/9.jpg"
import image10 from "../../assets/images/gallery/10.jpg"
import image11 from "../../assets/images/gallery/11.jpg"
import image12 from "../../assets/images/gallery/12.jpg"
import image13 from "../../assets/images/gallery/13.jpg"
import image14 from "../../assets/images/gallery/14.jpg"
import image15 from "../../assets/images/gallery/15.jpg"
import image16 from "../../assets/images/gallery/16.jpg"
import image17 from "../../assets/images/gallery/17.jpg"
import image18 from "../../assets/images/gallery/18.jpg"
import image19 from "../../assets/images/gallery/19.jpg"
import image20 from "../../assets/images/gallery/20.jpg"
import image21 from "../../assets/images/gallery/21.jpg"
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function GalleryOverlay({openModal}) {
  const [showMore, setShowMore] = useState(false);
  
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);

  const images = [
    { src: image1, alt: 'clip-images 1' },
    { src: image2, alt: 'clip-images 2' },
    { src: image3, alt: 'clip-images 3' },
    { src: image4, alt: 'clip-images 4' },
    { src: image5, alt: 'clip-images 5' },
    { src: image6, alt: 'clip-images 6' },
    { src: image7, alt: 'clip-images 7' },
    { src: image8, alt: 'clip-images 8' },
    { src: image9, alt: 'clip-images 9' },
    { src: image10, alt: 'clip-images 10' },
    { src: image11, alt: 'clip-images 11' },
    { src: image12, alt: 'clip-images 12' },
    { src: image13, alt: 'clip-images 13' },
    { src: image14, alt: 'clip-images 14' },
    { src: image15, alt: 'clip-images 15' },
    { src: image16, alt: 'clip-images 16' },
    { src: image17, alt: 'clip-images 17' },
    { src: image18, alt: 'clip-images 18' },
    { src: image19, alt: 'clip-images 19' },
    { src: image20, alt: 'clip-images 20' },
    { src: image21, alt: 'clip-images 21' },
  ];

  const initialImages = window.innerWidth <= 768 ? 6 : 9;
  const visibleImages = showMore ? images : images.slice(0, initialImages);

  return (
    <>
      <div className="gallery_wrapper" id="gallery">
        <div className="container">
          <div className="section_title">
            <h2 data-aos="fade-up">Gallery</h2>
          </div>
          <LightGallery
            speed={500}
            plugins={[lgThumbnail, lgZoom]}
            zoom={true}
            selector=".masonry-item" // specify a selector for zoom items
          >
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
              <Masonry gutter="10px">
                {visibleImages.map((image, index) => (
                  <a
                    data-aos="fade-up"
                    href={image.src}
                    data-src={image.src}
                    key={index}
                    className="masonry-item"
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="gallery_image"
                      style={{ width: "100%", borderRadius: "8px" }}
                    />
                  </a>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </LightGallery>
          <div className="button_area">
            <button onClick={() => setShowMore(!showMore)} className="simple_btn white_bg">
              {showMore ? "Show Less" : "Show More"}
            </button>
          </div>
          <div className='gallery_bottom_area' data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
            <h2>Experience Luxury Like Never Before</h2>
            <p>Ready to elevate your sea adventures? Deus Ex Machina offers a seamless blend of luxury and adventure. Don't miss the chance to create unforgettable memories.</p>
            <button className="simple_btn white_bg" onClick={openModal}>
              Contact
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
